import React from 'react'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'

interface GenericCheckboxProps {
  isChecked: boolean;
  isIndeterminate: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  name?: string
  disabled?: boolean
  value?: number
}

const GenericCheckbox: React.FC<GenericCheckboxProps> = ({
  isChecked,
  isIndeterminate,
  onChange,
  label,
  name,
  disabled = false,
  value,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Checkbox
      name={name}
      value={value?.toString()}
      checked={isChecked}
      indeterminate={isIndeterminate}
      onChange={onChange}
      disabled={disabled}
    />
    <Typography>{label}</Typography>
  </Box>
)

export default GenericCheckbox
